const config = {
    apiUrl: 'https://fidilio.com/',
    apiSlug: 'pitza_hot',
};

export default config;
